<style lang="scss" scoped>
.exch-name {
  color: #b4b4b4;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  padding-left: 0px;
}

.exch-value {
  font-size: 14px;
  text-align: center;
  padding-right: 0px;
  color: #e6e6e6;
}

.exch-img {
  height: 18px;
  padding: 2px;
  filter: brightness(10%);
}

.notactive-exch-name {
  color: #b4b4b4;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  padding-left: 0px;
}

.notactive-exch-value {
  color: var(--color-text-light);
  font-size: 14px;
  text-align: center;
  padding-right: 0px;
}

.active {
  &.pause {
    background-image: linear-gradient(
      to bottom left,
      #ffd57b,
      #a67d28
    ) !important;

    .exch-name {
      color: var(--color-background);
    }

    .exch-value {
      color: var(--color-card);
    }
  }
  &.free {
    background-image: linear-gradient(
      to bottom left,
      #64a6c6,
      #216180
    ) !important;
  }
}

.firstCell {
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
  /*border: 1px solid #eee;*/
}
.settingsbtn {
  position: absolute;
  top: 4px;
  right: -1px;
  color: var(--color-card);
}
.arrow-icon {
  position: absolute;
  bottom: 0px;
  left: 2px;
  color: var(--color-card);
}
.dropbtn {
  /*background-color: #4CAF50;*/
  font-size: 30px;
  border: none;
  cursor: pointer;
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dropdown {
  position: relative;
  display: inline-block;
  width: 100%;
  text-align: center;
}

.dropdown-content {
  display: none;
  position: absolute;
  left: 0px;
  /*background-color: var(--color-card);*/
  background-color: var(--color-card);
  width: 139px;
  /*box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);*/
  z-index: 100;
  margin-right: 10px;
  border-radius: 5px;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 23%);
}

.dropdown:not(.nodisplay):hover .dropdown-content:not(.nodisplay) {
  display: block;
}

.nodisplay {
  /*display: none !important;*/
}

.exchbtnborderbottom {
  text-align: center;
  width: 139px;
  height: 100%;
  padding-top: 2px;
  font-weight: bold;
  font-size: 14pt;
  /*line-height: 18pt;*/
  display: inline-block;
  cursor: pointer;
  position: relative;
  /*overflow-y: hidden;*/
  /*box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);*/

  &:first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  &:last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}

.bottomborder {
  border-bottom: 1px solid var(--color-border);
}

.exchbtnborderbottom:hover {
  background-image: linear-gradient(
    to bottom left,
    var(--color-accent-dark),
    var(--color-accent)
  );

  .notactive-exch-value {
    color: #e6e6e6;
  }
}
</style>

<template>
  <div
    class="dropdown"
    v-if="$store.state.sys.exchanges && $store.state.sys.exchanges.length > 0"
  >
    <div class="dropbtn">
      <div
        class="exchbtn active firstCell"
        :class="{free: isExchangeFree, pause: isExchangePaused}"
        style="height: 70px"
        @click="showDropdown()"
      >
        <Icon
          @click='showEditModal(curExch)'
          class="settingsbtn"
          type="md-more"
        />
        <div class="exch-name">
          {{ curExch.Name }}
        </div>
        <div style="height: 22px;">
          <img
            :src="getExUrl(curExch.ExchId)"
            class="exch-img"
          />
        </div>
        <div
          class="exch-value"
          :class="{'blur-balance': $store.state.sys.hideBalances}"
        >
          <div>{{ exchValue(curExch.Id) }}</div>
        </div>
        <Icon
          class="arrow-icon"
          size="23"
          type="ios-arrow-down"
        />
      </div>
    </div>
    <div
      class="dropdown-content"
      :class="{nodisplay: nodisp || (!$store.state.trade.tvEnabled  && $store.state.trade.tvLoading) }"
    >
      <div
        v-for='(exch, index) in notactiveexchanges'
        :key='exch.Id'
        class='exchbtnborderbottom'
        :class="{bottomborder: index < notactiveexchanges.length-1}"
        style="height: 70px"
        @click='selectExch(exch)'
      >
        <div class="notactive-exch-name">
          {{ exch.Name }}
        </div>
        <div style="height: 22px;">
          <img
            :src="getExUrl(exch.ExchId)"
            class="exch-img"
          />
        </div>
        <div
          class="notactive-exch-value"
          :class="{'blur-balance': $store.state.sys.hideBalances}"
        >
          <div>{{ exchValue(exch.Id) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { saveTradeExchange } from '@/store/index'

export default {
  name: 'ExchChooser',
  data () {
    return {
      nodisp: false
    }
  },
  computed: {
    isExchangePaused () {
      return this.$store.state.sys.tradeExchange.Status === 'PAU'
    },
    isExchangeFree () {
      return this.$store.state.sys.tradeExchange.Free === true
    },
    curExch () {
      return this.$store.state.sys.tradeExchange
    },
    notactiveexchanges () {
      if (!this.$store.state.sys.exchanges) {
        return []
      }
      return this.$store.state.sys.exchanges.filter(exch => {
        return exch.Id !== this.curExch.Id
      })
    }
  },
  created () {
    // console.log(this.curExch)
    // console.log(this.$store.state.sys.exchanges)
    // this.ind = this.$store.state.sys.exchanges.indexOf(this.curExch)
  },
  methods: {
    getExUrl (ex) {
      const isDark = this.$store.state.sys.theme === 'dark'
      switch (ex) {
        case 'BIN':
        case 'BIM':
          return require('@/assets/exlogo/bin.svg')
        case 'BIF':
          return require('@/assets/exlogo/bif.svg')
        case 'BIT':
          return require('@/assets/exlogo/bit.png')
        case 'EXM':
          return isDark ? require('@/assets/exlogo/exm_dark_theme.svg') : require('@/assets/exlogo/exm.svg')
        case 'HUO':
          return isDark ? require('@/assets/exlogo/htx_dark_theme.svg') : require('@/assets/exlogo/htx.svg')
        case 'FTX':
          return require('@/assets/exlogo/ftx.svg')
        case 'OKX':
          return isDark ? require('@/assets/exlogo/okx_dark_theme.svg') : require('@/assets/exlogo/okx.svg')
        case 'BYF':
          return isDark ? require('@/assets/exlogo/byf_dark_theme.svg') : require('@/assets/exlogo/byf.svg')
        case 'BYB':
          return isDark ? require('@/assets/exlogo/byb_dark_theme.svg') : require('@/assets/exlogo/byb.svg')
        case 'GET':
          return isDark ? require('@/assets/exlogo/get_dark_theme.svg') : require('@/assets/exlogo/get.svg')
        case 'GEF':
          return isDark ? require('@/assets/exlogo/gef_dark_theme.svg') : require('@/assets/exlogo/gef.svg')
      }
      // return require('@/assets/exlogo/' + ex + '.png')
    },
    exchValue (eid) {
      if (this.$store.state.sys.exchValue[eid]) {
        switch (this.$store.state.sys.usdbtc) {
          case 'USD':
            return '$' + this.$store.state.sys.exchValue[eid].usd
          case 'BTC':
            return this.$store.state.sys.exchValue[eid].btc + ' BTC'
        }
      }
    },
    showEditModal (index) {
      this.$store.state.show.exchangeModalIndex = 1
      this.$store.state.show.exchangeModal = true
    },
    selectExch (exch) {
      // console.log(index)
      this.$store.state.trade.editTradeId = null
      this.$store.state.trade.editTrade = null
      this.$store.state.sys.tradeExchange = exch
      this.$store.state.assets.allexchs = false
      saveTradeExchange(this.$store.state.sys.tradeExchange, this.$store.state.sys.demo)
      this.nodisp = true
    },
    showDropdown () {
      this.nodisp = false
    }
  }
}
</script>
